import { useIsAuthenticated } from "@azure/msal-react";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import ExitToAppIcon from "@mui/icons-material/ExitToApp";
import HomeIcon from "@mui/icons-material/Home";
import {
  AppBar,
  Divider,
  Drawer,
  IconButton,
  List,
  ListItem,
  ListItemIcon,
  ListItemText,
  Toolbar,
  Typography,
} from "@mui/material";
import { grey } from "@mui/material/colors";
import { ReactElement, useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { version } from "../../package.json";
import { apiGetCurrentUser } from "../api";

interface HeaderProps {
  onLogoutClick: () => void;
}

export default function Header(props: HeaderProps): ReactElement {
  const isAuthenticated = useIsAuthenticated();

  const [isAdmin, setIsAdmin] = useState(false);
  const [email, setEmail] = useState("");

  useEffect(() => {
    if (!isAuthenticated) return;

    apiGetCurrentUser()
      .then((data) => {
        setIsAdmin(data.isAdmin);
        setEmail(data.email);
      })
      .catch(() => {
        setIsAdmin(false);
        setEmail("");
      });
  }, [isAuthenticated]);

  const [isDrawerOpen, setIsDrawerOpen] = useState(false);

  const openDrawer = () => {
    setIsDrawerOpen(true);
  };

  const closeDrawer = () => {
    setIsDrawerOpen(false);
  };

  return (
    <AppBar
      position="static"
      elevation={3}
      style={{ backgroundColor: grey[50] }}
    >
      <Toolbar>
        <Link to="/">
          <img
            src={process.env.PUBLIC_URL + "/dm_logo.png"}
            alt=""
            style={{
              height: "52px",
              verticalAlign: "middle",
              paddingRight: "2rem",
            }}
          />
        </Link>
        <Typography
          variant="subtitle2"
          color="inherit"
          noWrap
          style={{ color: grey[900], flexGrow: 1 }}
        >
          D&amp;M Stocks Voting&nbsp;
          <Typography
            variant="subtitle2"
            component="span"
            style={{ color: "#666" }}
          >
            version {version}
          </Typography>
        </Typography>
        {isAuthenticated && (
          <>
            <Typography variant="subtitle2" style={{ color: grey[900] }}>
              {email}
            </Typography>
            <IconButton onClick={openDrawer}>
              <AccountCircleIcon />
            </IconButton>
          </>
        )}
      </Toolbar>
      <Drawer anchor="right" open={isDrawerOpen} onClose={closeDrawer}>
        <List style={{ width: 250 }}>
          <ListItem
            button
            component={Link}
            to="/"
            key="home"
            onClick={closeDrawer}
          >
            <ListItemIcon>
              <HomeIcon />
            </ListItemIcon>
            <ListItemText primary="Home" />
          </ListItem>
        </List>
        <Divider />
        {isAdmin && (
          <>
            <List style={{ width: 250 }}>
              <ListItem
                button
                component={Link}
                to="/stocks"
                key="viewstocks"
                onClick={closeDrawer}
              >
                {/* <ListItemIcon><HomeIcon /></ListItemIcon> */}
                <ListItemText primary="View Stocks/Royalties" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/users"
                key="manageusers"
                onClick={closeDrawer}
              >
                {/* <ListItemIcon><HomeIcon /></ListItemIcon> */}
                <ListItemText primary="Manage Users" />
              </ListItem>
              <ListItem
                button
                component={Link}
                to="/emails"
                key="manageemails"
                onClick={closeDrawer}
              >
                {/* <ListItemIcon><HomeIcon /></ListItemIcon> */}
                <ListItemText primary="Manage E-mail notifications" />
              </ListItem>
            </List>
            <Divider />
          </>
        )}
        <List>
          <ListItem button key="logout" onClick={props.onLogoutClick}>
            <ListItemIcon>
              <ExitToAppIcon />
            </ListItemIcon>
            <ListItemText primary="Logout" />
          </ListItem>
        </List>
      </Drawer>
    </AppBar>
  );
}
